module.exports = __webpack_public_path__ + "static/img/test2.d3f16e42.png";